<template>
	<Layout>
		<div class="ui form warning" style="text-align: center;">
			<h2 class="ui center aligned icon header">
				<i class="circular book icon"></i>
				<div class="content">
					{{ getAreaDeConocimiento.nombre }}
					<div class="sub header" style="text-align:left;">
						<base-mostrar-markdown
							:contenido="getAreaDeConocimiento.introduccion"
						/>
					</div>
				</div>
			</h2>
			<div v-show="!getEsTiempoDeEmpezar" class="ui warning message">
				<div class="header">¡Tiempo de descanso!</div>
				<p>
					El valor del indicador establece el tiempo restante para el inicio de
					la siguiente área de conocimiento.
				</p>
				<b>
					No podras iniciar la siguiente área hasta que se cumpla el tiempo
					indicado.
				</b>
			</div>
			<button
				class="ui animated button secondary"
				:disabled="!getEsTiempoDeEmpezar"
				tabindex="0"
				@click="iniciar"
			>
				<div class="visible content">Iniciar</div>
				<div class="hidden content">
					<i class="right arrow icon"></i>
				</div>
			</button>
		</div>
	</Layout>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Layout from '@layouts/examen.vue';
import Notification from '@utils/notification';

export default {
	components: { Layout },
	computed: {
		...mapGetters('oidc', ['oidcUser']),
		...mapGetters('examenAspirante', [
			'getExamenAspirante',
			'getPermisoCamara',
			'getPermisoScreen'
		]),
		...mapGetters('areaDeConocimiento', ['getAreaDeConocimiento']),
		...mapGetters('indicadores', ['getEsTiempoDeEmpezar']),
		...mapGetters('configuraciones', [
			'getEnableFullScreen',
			'getEnableCameraRecorder',
			'getEnableScreenRecorder'
		]),
		permisoGrabar() {
			if (this.getEnableCameraRecorder && this.getEnableScreenRecorder) {
				return this.getPermisoCamara && this.getPermisoScreen;
			} else if (this.getEnableCameraRecorder) {
				return this.getPermisoCamara;
			} else if (this.getEnableScreenRecorder) {
				return this.getPermisoScreen;
			}
			return true;
		}
	},
	mounted: function() {
		this.obtenerAreaDeConocimiento({
			ficha: this.oidcUser.username,
			onComplete: () => {
				this.obtenerIndicadorEspera({
					ficha: this.oidcUser.username
				});
			}
		});
		this.ENTRO_A_AREA({});

		// window.removeEventListener('blur', () => {});
	},
	methods: {
		...mapActions('examenAspirante', ['siguiente']),
		...mapActions('areaDeConocimiento', [
			'obtenerAreaDeConocimiento',
			'iniciarAreaDeConocimiento'
		]),
		...mapActions('indicadores', [
			'obtenerIndicador',
			'obtenerIndicadorEspera'
		]),
		...mapMutations('examenAspirante', ['ENTRO_A_AREA']),
		iniciar() {
			if (!this.permisoGrabar)
				return Notification(
					'error',
					'Favor de dar permiso de grabación para continuar con la realización del examen'
				);
			this.iniciarAreaDeConocimiento({
				ficha: this.oidcUser.username,
				onComplete: (resposeDatos) => {
					this.siguiente({
						ficha: this.oidcUser.username,
						onComplete: (resposeDatos) => {
							this.$router.push('seccion');
						},
						onError: (resposeDatos) => {
							this.$router.push('inicio');
						}
					});
				}
			});
		}
	}
};
</script>
